import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=0c8ec528&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=0c8ec528&prod&lang=less&scoped=true"
import style1 from "./PageHeader.vue?vue&type=style&index=1&id=0c8ec528&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ec528",
  null
  
)

export default component.exports